import { useQuery } from "@tanstack/react-query";

import { shop } from "@/api/shop";
import { Price } from "@/components/Price";

const STATUS: Record<string, { cls: string; label: string }> = {
  paid: { cls: "bg-brand-soft text-brand-strong", label: "Paid" },
  pending: { cls: "bg-amber-100 text-warn", label: "Pending" },
  failed: { cls: "bg-rose-100 text-down", label: "Failed" },
  refunded: { cls: "bg-surface-alt text-ink-soft", label: "Refunded" },
  canceled: { cls: "bg-surface-alt text-ink-mute", label: "Canceled" },
};

export function Orders() {
  const { data, isLoading } = useQuery({ queryKey: ["shop", "orders"], queryFn: shop.orders });

  return (
    <div className="mx-auto max-w-2xl">
      <h1 className="text-2xl font-extrabold tracking-tight text-ink">Order history</h1>
      {isLoading && <p className="mt-3 text-ink-soft">Loading…</p>}
      {data && data.orders.length === 0 && (
        <p className="mt-4 rounded-xl border border-line bg-surface p-6 text-ink-mute">
          You haven't placed any orders yet.
        </p>
      )}
      <div className="mt-4 space-y-3">
        {data?.orders.map((o) => {
          const s = STATUS[o.status] ?? { cls: "bg-surface-alt text-ink-soft", label: o.status };
          return (
            <div key={o.id} className="rounded-xl border border-line bg-surface p-5 shadow-card">
              <div className="flex items-center justify-between">
                <span className="text-sm text-ink-mute">
                  {o.created_at ? new Date(o.created_at).toLocaleString() : ""} · {o.id.slice(0, 8)}
                </span>
                <span className={`rounded-full px-2.5 py-1 text-xs font-semibold ${s.cls}`}>
                  {s.label}
                </span>
              </div>
              <div className="mt-3 space-y-1">
                {o.items.map((i) => (
                  <div key={i.sku_code} className="flex justify-between text-sm text-ink-soft">
                    <span>
                      {i.product_name} <span className="text-ink-mute">× {i.quantity}</span>
                    </span>
                    <Price cents={i.unit_price_cents * i.quantity} currency={o.currency} />
                  </div>
                ))}
              </div>
              <div className="mt-3 flex justify-between border-t border-line pt-3 font-bold text-ink">
                <span>Total</span>
                <Price cents={o.total_cents} currency={o.currency} />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
